/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  ChangePersonalInfoDto,
  User,
  UserInviteOldDTO,
  UserUpdateDTO,
  UsersControllerV1CreateUserAndInviteV1PathParameters,
  UsersControllerV1GetClientAccessListV1200,
  UsersControllerV1ResendInviteOldV1PathParameters,
  UsersControllerV1ResetTotpV1PathParameters,
  UsersControllerV1UpdateUserV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly http = inject(HttpClient);
  /**
   * @deprecated
   * @summary Get the list of clients the user has access to
   */

  getClientAccessList<TData = UsersControllerV1GetClientAccessListV1200>(): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/users/current/clients`);
  }
  /**
   * @summary Change user’s personal information
   */

  changePersonalInfo<TData = User>(changePersonalInfoDto: ChangePersonalInfoDto): Observable<TData> {
    return this.http.patch<TData>(`/clients/v1/users/current`, changePersonalInfoDto);
  }
  /**
   * @summary Create a user and send an invite
   */

  createUserAndInvite<TData = User>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: UsersControllerV1CreateUserAndInviteV1PathParameters,
    userInviteOldDTO: UserInviteOldDTO,
  ): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/users`, userInviteOldDTO);
  }
  /**
   * @summary Resend an invitation email to a user
   */

  resendInviteOld<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    userId,
  }: UsersControllerV1ResendInviteOldV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients/${clientId}/users/${userId}/resend-invite`);
  }
  /**
   * @summary Update user details
   */

  updateUser<TData = User>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, userId }: UsersControllerV1UpdateUserV1PathParameters,
    userUpdateDTO: UserUpdateDTO,
  ): Observable<TData> {
    return this.http.patch<TData>(`/clients/v1/clients/${clientId}/users/${userId}`, userUpdateDTO);
  }
  /**
   * @summary Reset a user's TOTP enrollment and grant a fresh 7-day setup grace period
   */

  resetTotp<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    userId,
  }: UsersControllerV1ResetTotpV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/users/${userId}/totp/reset`, undefined);
  }
}
